<template lang="html">
    <div id="businessDetails"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <businessBar :tags="tags"
                     :title="title"
                     :date="date"
                     :subTitle1="subTitle1"
                     :subTitle2="subTitle2"
                     :inspection_num="inspection_num"
                     :address="address"
                     :distributor_grade="distributor_grade"
                     :btnBack="true" :btnRepeal="onoffManager"
                     :btnSave="saveBtn"
                     :btnCompleted="completedBtn"
                     :checkInArr="checkInArr"
                     @btnRepealClick="delInstitutionsVisit"  @btnBackClick="handleBackClick" @btnSaveClick="SaveClick" @btnCompletedClick="handleCompletedClick"/>
        <div id="business">
            <el-form>
                <el-row>
                    <el-col>
                        <el-form-item label="拜访日期">
                            <el-date-picker
                                    v-model="date"
                                    type="date"
                                    format="yyyy年M月d日"
                                    value-format="yyyy年MM月dd日"
                                    placeholder="选择日期"
                                    style="width: 25%"
                                    disabled>
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
<!--                    <el-col>-->
<!--                        <el-form-item label="拜访类型">-->
<!--                            <el-select v-model="visitType" placeholder="请选择拜访类型" disabled style="width:25%">-->
<!--                                <el-option-->
<!--                                        v-for="item in options_type"-->
<!--                                        :key="item.key"-->
<!--                                        :label="item.value1"-->
<!--                                        :value="item.key">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col>
                        <el-form-item label="拜访目的">
                            <el-select v-model="visitPurpose" placeholder="请选择拜访目的" :disabled="!saveBtn" style="width:25%" clearable>
                                <el-option
                                        v-for="item in options_purpose"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div style="margin-top: 13px">
            <el-tabs v-model="activeName" @tab-click="">
                <el-tab-pane label="联系人" name="second">
                    <el-row style="display: flex;flex-wrap: wrap;">
                        <el-col>
                            <el-button type="success" size="small" v-if="onoffManager" @click.stop="newContactClick"
                                       :disabled="disabled" style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px; font-size:13px">
                                <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                                添加
                            </el-button>
                        </el-col>
                        <el-col v-for="(item,j) in contactList"
                                style="border: 1px solid #ededed;width: 400px;margin-top: 10px;margin-right: 20px;position: relative;height: 90px">
                            <div
                                    style="display: inline-block;position: relative;width: 50px;
                                        height: 50px;border-radius: 50%;margin:15px auto 0;">
                                <img src="../../../assets/images/tou.png" width="100%" alt=""

                                     style="position: absolute;top: 50%;left: 50%;margin-left: 20px;
                                         transform: translate(-50%,-50%);">
                            </div>


                            <span style="position: relative;top:-40px;margin-left: 30px">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                                                 <span style="color: #4D586D;font-size: 15px;">{{item.contact_name}}</span>
                                                 <span v-if="item.pro_title" style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
                                            </span>
                            <span
                                    style="color: #ff9901;float: right;padding-top: 12px;font-size: 15px;padding-right: 10px;cursor:pointer;" @click.stop="getContactVisitInfo_remove(item.activity_id,item)" v-if="editOnOff">
                                                移除
                                            </span>
                            <span style="color: #ff9901;float: right;padding-top: 12px;font-size: 15px;padding-right: 10px;cursor:pointer;" @click.stop="getContactVisitInfo(item.activity_id,item)"  @click="contactBool=true" v-if="editOnOff">
                                                编辑
                                            </span>
                            <span style="position: absolute;top: 32px;left: 85px">
                                 <span style="font-size: 13px;color:#B0B5B9" v-if="item.department">
                                                {{item.department}} |
                                              </span>
                                              <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                                                {{item.job_title}}
                                              </span>
                                </span>
                            <span style="color: #4A90E2;font-size: 13px;position: absolute;top: 55px;left: 85px">
                                <span style="font-size: 13px;color: rgb(77, 88, 109)" >
                                                  {{item.distributor_name}}
                                              </span>

                                </span>
                            <!--                                <div style="width: 311px;float: right">-->
                            <!--                                    -->
                            <!--                                </div>-->

                            <el-row style="margin-bottom: 10px">
                            </el-row>

                        </el-col>

                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="库存采集" name="first">
                    <inventory :onoffManager="onoffManager"></inventory>
                </el-tab-pane>
                <el-tab-pane label="待办事项" name="third">
                    <addTodoList ref="addTodoForm" :onoffManager="onoffManager" :title="title"></addTodoList>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!--        删除-->
<!--        <el-dialog-->
<!--                title="提示"-->
<!--                :visible.sync="dialogVisible"-->
<!--                width="30%">-->
<!--            <span>是否确定删除此条商务拜访</span>-->
<!--            <span slot="footer" class="dialog-footer">-->
<!--                <el-button type="primary" @click.stop="delInstitutionsVisit" @click="dialogVisible = false">确 定</el-button>-->
<!--                <el-button @click="dialogVisible = false">取 消</el-button>-->
<!--            </span>-->
<!--        </el-dialog>-->
        <el-dialog
                :visible.sync="contactBool"
                :before-close="handleClose"
                width="900px"
                :show-close="false"
                style="vertical-align: center;color: #FFF9F3;">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 20px;padding-top:10px">拜访联系人
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="inputAddContact" :disabled="disabled">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="closeAddBool" @click="">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="waitList" style="margin-top: 5px;">
                    <el-form ref="contactForm" :model="addContact" label-width="100px" hide-required-asterisk>
                        <el-row>
                            <el-col>
                                <el-form-item label="经销商">
                                    <p style="color: #3b99f7;font-size: 14px;margin: 0px;font-weight: bold">{{title}}</p>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="联系人" class="dropDetails_star" :rules="[{required:true,message:'联系人不能为空'}]" prop="contact_name">
                                        <el-select
                                            v-model="addContact.contact_name"
                                             filterable
                                             value-key="contact_id"
                                             @change="choseProvince"
                                             :disabled="contactDisabled"
                                             placeholder="请选择联系人"
                                             style="width: 100%;" clearable>
                                             <el-option
                                              v-for="item in options_contact"
                                              :key="item.contact_id"
                                               :label="item.contact_name"
                                               :value="item">
                                               </el-option>
                                         </el-select>
<!--                                    <el-cascader-->
<!--                                            v-model="addHcp.hcp_name"-->
<!--                                            :options="options_hcp"-->
<!--                                            :show-all-levels="false"-->
<!--                                            :disabled="hcpdisabled"-->
<!--                                            @change="choseProvince"-->
<!--                                            style="width:100%"-->
<!--                                            clearable-->
<!--                                    >-->
<!--                                    </el-cascader>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">&nbsp;</el-col>
                            <el-col :span="11">
                                <el-form-item label="拜访时间">
                                    <el-date-picker
                                            v-model="addContact.activity_date"
                                            type="date"
                                            disabled
                                            format="yyyy年M月d日"
                                            value-format="yyyy年MM月dd日"
                                            placeholder="请选择拜访日期"
                                            style="width: 100%;">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <!--                            <el-col :span="12">-->
                            <!--                                <el-form-item label="拜访类型">-->
                            <!--                                    <el-select v-model="addHcp.call_type" placeholder="请选择拜访类型" :disabled="disabled"style="width: 300px;">-->
                            <!--                                        <el-option-->
                            <!--                                                v-for="item in options_hcpType"-->
                            <!--                                                :key="item.key"-->
                            <!--                                                :label="item.value1"-->
                            <!--                                                :value="item.key">-->
                            <!--                                        </el-option>-->
                            <!--                                    </el-select>-->
                            <!--                                </el-form-item>-->
                            <!--                            </el-col>-->
                            <el-col :span="11">
                                <el-form-item label="拜访目的" class="dropDetails_star" :rules="[{required:true,message:'拜访目的不能为空'}]" prop="objective_id">
                                    <el-select v-model="addContact.objective_id" placeholder="请选择拜访目的" :disabled="disabled" style="width: 100%;" clearable>
                                        <el-option
                                                v-for="item in options_contactPurpose"
                                                :key="item.key"
                                                :label="item.value1"
                                                :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">&nbsp;</el-col>
                            <el-col :span="11">
                                <el-form-item label="产品"  prop="product_id">
                                    <el-select v-model="addContact.product_id" placeholder="请选择产品" :disabled="disabled" style="width: 100%;"clearable>
                                        <el-option
                                                v-for="item in options_contactProduct"
                                                :key="item.key"
                                                :label="item.value1"
                                                :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="沟通内容">
                                    <el-input
                                            type="textarea"
                                            :rows="4"
                                            placeholder="请输入沟通内容"
                                            v-model="addContact.conversation"
                                            :disabled="disabled"
                                            style="width: 100%;">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="客户反馈" class="dropDetails_star" :rules="[{required:true,message:'客户反馈不能为空'}]" prop="feedback">
                                    <el-select v-model="addContact.feedback"  placeholder="请选择客户反馈" :disabled="disabled" style="width: 100%;"clearable>
                                        <el-option
                                                v-for="item in options_feedback"
                                                :key="item.key"
                                                :label="item.title"
                                                :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>
                <el-row style="padding-bottom: 10px;margin-top:10px">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 20px;padding-top:10px">待办事项
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="success" size="small" @click.stop="backlogClick" @click="backlog=!backlog" :disabled="disabled" style="float: right;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;font-size:13px">
                                <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                                添加待办事项
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="backlog" v-if="backlog" style="width: 100%; background-color: rgba(74,144,226,0.1);">
                    <el-form ref="todoForm" :model="addTodo" label-width="100px" hide-required-asterisk>
                        <el-row>
                            <el-col :span="12" style="margin-top: 10px">
                                <el-form-item label="标题" class="dropDetails_star" :rules="[{required:true,message:'标题不能为空'}]" prop="title">
                                    <el-input v-model="addTodo.title" placeholder="请填写标题" style="width: 250px;" ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11" style="margin-top:21px;text-align: right;margin-right: 20px;">
                                <el-button size="small" type="primary" @click.stop="inputAddTodoContactList">
                                    保存
                                </el-button>
                                <el-button size="small" @click.stop="closeAddBlock" type="danger" >
                                    取消
                                </el-button>
                            </el-col>
                            <el-col>
                                <el-form-item label="截止日期" style="margin-top: 10px" class="dropDetails_star" :rules="[{required:true,message:'截止日期不能为空'}]" prop="duedate">
                                    <el-date-picker
                                            v-model="addTodo.duedate"
                                            type="date"
                                            format="yyyy-M-d"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择截止日期"
                                            :picker-options="pickerOptions"
                                            style="width: 250px;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="说明" style="margin-top: 20px">
                                    <el-input
                                            type="textarea"
                                            :rows="2"
                                            placeholder="请输入联系的具体内容"
                                            v-model="addTodo.content"
                                            style="width: 712px;">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <el-row v-if="todoContactList.length>0">
                    <el-col v-for="(item,i) in todoContactList"  style="border: 1px solid #ededed;width: 400px;margin-top: 15px;margin-right: 20px">
                        <p style="font-size: 20px;color: #4D586D;padding-left: 20px;" v-if="editOnOff">{{item.title}}<span style="float: right;cursor:pointer;margin-right: 20px;color: #ff9901;font-size: 15px;" @click.stop="editorTodoList(item,i)" @click="waitBool=true">编辑</span></p>
                        <p style="font-size: 14px;color: #B0B5B9;padding-left: 20px;margin:0;" v-if="item.reference_obj == 'DISTRIBUTOR'">
                            <span v-if="item.reference_obj == 'DISTRIBUTOR'">{{item.distributor_name}}</span>
                        </p>
                        <p style="font-size: 14px;color: #B0B5B9;padding-left: 20px;" v-if="item.reference_obj == 'CONTACT'">
                            <span style="" v-if="item.department" >{{item.department}} |</span>
                            <span v-if="item.job_title" style="">{{item.job_title}} |</span>
                            <span v-if="item.contact_name" >{{item.contact_name}}</span>
                        </p>
                        <p style="color: #4ec880;font-size: 15px;padding-left: 20px;">截止日期：{{item.duedate|date}}</p>
                    </el-col>
                </el-row>
                <el-row v-if="todoContactList.length==0&&!backlog">
                    <img src="../../../assets/images/icon_empty.png" style="margin: 0 auto;display:block">
                </el-row>
            </div>

        </el-dialog>
        <el-dialog
                :visible.sync="waitBool"
                width="700px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div id="waitBool_id">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">待办事项
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="inputAddTodoList()" :disabled="disabled" >
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="closeWaitBool">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="back" style="margin-top: 20px;">
                    <el-form ref="todoFormList" :model="addTodoDate" label-width="15%" style="margin-left: 100px" hide-required-asterisk>
                        <el-form-item label="标题" class="dropDetails_star" :rules="[{required:true,message:'标题不能为空'}]" prop="title">
                            <el-input v-model="addTodoDate.title" placeholder="请填写标题" :disabled="disabled" style="width: 70%;margin-left:5%;" ></el-input>
                        </el-form-item>
                        <el-form-item label="截止日期" class="dropDetails_star" :rules="[{required:true,message:'截止日期不能为空'}]" prop="duedate">
                            <el-date-picker
                                    v-model="addTodoDate.duedate"
                                    type="date"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择截止日期"
                                    :picker-options="pickerOptions"
                                    :disabled="disabled"
                                    style="width: 70%;margin-left:5%;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="关联对象" >
                            <p style="color: #3b99f7;font-size: 14px; margin-top: 0px;margin-bottom: 0px;margin-left:5%;">
                                {{addTodoDate.distributor_name}}
                                <span v-if="addTodoDate.job_title"> | {{addTodoDate.job_title}}</span>
                                <span v-if="addTodoDate.contact_name"> | {{addTodoDate.contact_name}}</span>
                            </p>
                        </el-form-item>
                        <el-form-item label="说明">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请填写说明"
                                    v-model="addTodoDate.content"
                                    :disabled="disabled"
                                    style="width: 70%;margin-left:5%;">
                            </el-input>
                        </el-form-item>
<!--                        <el-form-item label="上传照片">-->
<!--                            <el-upload-->
<!--                                    ref="displayUpload"-->
<!--                                    :limit="9"-->
<!--                                    accept=".jpg,.png,.jpeg"-->
<!--                                    action="/photos/uploadphoto"-->
<!--                                    list-type="picture-card"-->
<!--                                    :on-preview="dialogVisibles"-->
<!--                                    :on-remove="handleRemove"-->
<!--                                    :on-change="handleChange"-->
<!--                                    :on-success="handleImgSuccess"-->
<!--                                    :before-upload="beforeImgUpload"-->
<!--                                    :data="displayChecImgData"-->
<!--                                    :file-list="fileList"-->
<!--                                    style="margin-left:5%;">-->

<!--                                <i class="el-icon-plus"></i>-->
<!--                            </el-upload>-->
<!--                            <p style="line-height:20px;margin-left:5%;">你可以上传多张JPG或PNG格式的图片文件,-->
<!--                                单个文件大小不能超过20M。</p>-->
<!--                        </el-form-item>-->

                    </el-form>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import businessBar from '../../../components/businessBar'
    import inventory from './components/inventory'
    import addTodoList from './components/addTodoList'
    import http from '../../../APIService/http'
    import moment from 'moment'
    export default {
        name: "medical",
        data() {
            return {
                displayChecImgData:{
                    reference_obj: 'CLIENT',
                    reference_id: 'com.saasyun.android',
                    credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    username:this.$store.getters.getUser.username,
                    user_id:this.$store.getters.getUser.user_id,
                    event_obj : 'CAMPAIGN',
                    category:'TODO',
                },
                id: "",
                loading: false,
                tags: ['辖区事务','商务拜访'],
                activeName: 'second',
                dialogVisible:false,
                title:'',
                date:'',
                subTitle1:'',
                subTitle2:'',
                data:{},
                address:'',
                activity_date:'',
                addTodo:{},
                pickerOptions:{
                    disabledDate: (time) => {
                        return time.getTime() + 24 * 3600 * 1000 < Date.now() || time.getTime() > Date.now() + 30*24 * 3600 * 1000
                    }
                },
                options_purpose:[],
                options_type:[],
                visitType:'',
                visitPurpose:'',
                distributor_grade:'',
                inspection_num:'',
                onoffManager:true,
                disabled:false,
                account_id:'',
                checkInArr:[],
                addContact:{},
                contactBool:false,
                options_contactProduct:[],
                options_feedback:[],
                todoContactList:[],
                options_contact:[],
                options_contactPurpose:[],
                backlog:false,
                newContact:{},
                contactDetail:{},
                contactList:[],
                territory_id:'',
                editOnOff:true,
                waitBool:false,
                addTodoDate:{},
                fileList:[],
                copyFileList:[],
                contactDisabled:false,
                index:'',
                completedBtn:false,
                saveBtn:false,
            }
        },
        components: {
            businessBar,
            inventory,
            addTodoList
            // Upload
        },
        created () {
            let condition = localStorage.getItem('condition')
            let data = JSON.parse(condition)
            if((this.$route.params.created_by === this.$store.getters.getUser.user_id) || (data.created_by === this.$store.getters.getUser.user_id) ){
                this.disabled = false
            }else{
                this.disabled = true
            }
        },
        mounted () {
            // document.getElementById('main').scrollTo(0, 0)
            if(Object.keys(this.$route.params).length === 0){
                let condition = localStorage.getItem('condition')
                this.status = 'INFO';
                // console.log(condition)
                this.data = JSON.parse(condition)
                if (!this.data.distributor_id){
                    this.data.distributor_id = this.data.activity_id
                }
                if (this.data.distributor_name) {
                    this.title = this.data.distributor_name;
                }else {
                    this.title = this.data.title
                }
                this.addTodo.distributor_name = this.title;
                this.date = this.data.activity_date;
                if(this.data.checkin_time){
                    this.subTitle1 = this.data.checkin_time
                }else{
                    this.subTitle1 = '尚未签入'
                }
                if(this.data.checkout_time){
                    this.subTitle2 = this.data.checkout_time
                }else{
                    this.subTitle2 = '尚未签出'
                }
                this.init()
            }else {
                this.status = 'INFO';
                this.data = this.$route.params;
                if (!this.data.distributor_id){
                    this.data.distributor_id = this.data.activity_id
                }
                if (this.data.distributor_name) {
                    this.title = this.data.distributor_name;
                }else {
                    this.title = this.data.title
                }
                this.addTodo.distributor_name = this.title;
                this.date = this.data.activity_date;
                if(this.data.checkin_time){
                    this.subTitle1 = this.data.checkin_time
                }else{
                    this.subTitle1 = '尚未签入'
                }
                if(this.data.checkout_time){
                    this.subTitle2 = this.data.checkout_time
                }else{
                    this.subTitle2 = '尚未签出'
                }
                this.init()
            }
            let user = this.$store.getters.getUser
            if (user.role !== 'staff' && this.$route.params.created_by !== user.user_id) {
                this.onoffManager =false
            }
        },
        filters: {
            date(value) {
                return moment(value).format('YYYY-M-D');
            }
        },

        methods: {
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    var str = this.data.activity_date;
                    // var year = str.split('')[0]+str.split('')[1]+str.split('')[2]+str.split('')[3];
                    // var month = str.split('')[5]+str.split('')[6];
                    // var day = str.split('')[8]+str.split('')[9];
                    // let date = (year+'-'+month+'-'+day)
                    var approvedates = str.replace(/[年月]/g,"-");
                    var date = approvedates.replace(/[日]/,"");
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        distributor_id : this.data.distributor_id,
                        activity_id:this.data.activity_id,
                        date : moment(date).format('YYYY-MM-DD')
                    }

                    await http.post('/wapi/Business/getDistributorVisitInfo',data).then(res=>{
                        if (res.success === true){
                            // console.log(res)
                            this.visitPurpose = res.data.infoObj.visitPurpose
                            this.visitType = res.data.infoObj.visitType
                            this.distributor_grade = res.data.infoObj.distributorObj.distributor_grade
                            this.address = res.data.infoObj.distributorObj.address
                            this.inspection_num = res.data.infoObj.distributorObj.inspection_num
                            this.account_id = res.data.infoObj.distributorObj.account_id
                            this.territory_id = res.data.infoObj.distributorObj.territory_id
                            if(res.data.infoObj.isClosed=='T'){
                                this.onoffManager=false
                                this.editOnOff=false
                            }
                            if(res.data.infoObj.planned =='T'&&!(res.data.infoObj.completed =='T')&&res.data.infoObj.created_by==data.user_id){
                                this.saveBtn = true
                                let nowDate = moment().format('YYYY-MM-DD').valueOf()
                                let activity_date = moment(res.data.infoObj.activity_date).format('YYYY-MM-DD').valueOf()
                                if((nowDate>=activity_date)&&!(res.data.infoObj.isClosed=='T')){
                                    this.completedBtn = true
                                }else {
                                    this.completedBtn = false
                                }
                            }else {
                                this.saveBtn = false
                            }
                        }
                    })
                    this.getAddContactList()
                    this.getDistributorTypeList();
                    this.getPurposeVisitList();
                    this.getCheckListById();
                    this.getContactList();
                    this.getContactFeedBackList();
                    this.getProductList()
                    this.getContactPurposeData()
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            // 获取拜访类型
            async getDistributorTypeList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    await http.post('/wapi/Business/getDistributorTypeList',data).then(res=>{
                        this.options_type = res.data
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            // 获取拜访目的
            async getPurposeVisitList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    await http.post('/wapi/Business/getPurposeVisitList',data).then(res=>{
                        if(res.success == true){
                            this.options_purpose = res.data
                        }

                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            handleBackClick(){
                this.$router.go(-1)
            },
            handleRepealClick(){
                this.dialogVisible = true
            },
            async delInstitutionsVisit(){

                this.$confirm('确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try{
                        // console.log(this.data)
                        let data={
                            tenant_id:this.$store.getters.getUser.tenant_id,
                            user_id:this.$store.getters.getUser.user_id,
                            activity_id : this.data.activity_id,
                            account_id : this.account_id
                        }
                        await http.post('/wapi/Business/delDistributorVisit',data).then(res=>{
                            if(res.success == true){
                                this.$router.go(-1)
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })
                            }
                        })
                    }catch (e) {
                        return e
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //获取签到
            async getCheckListById(){
                var str = this.$route.params.activity_date;
                var year = str.split('')[0]+str.split('')[1]+str.split('')[2]+str.split('')[3];
                var month = str.split('')[5]+str.split('')[6];
                var day = str.split('')[8]+str.split('')[9];
                let date = (year+'-'+month+'-'+day)
                let data ={
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    id :this.$route.params.distributor_id,
                    created_by : this.data.created_by,
                    date : date
                }

                await http.post('/wapi/Conference/getCheckListById',data).then(res=>{
                    this.checkInArr = res.data
                    console.log(this.checkInArr)
                })
            },
            getContactList(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id : this.data.distributor_id,
                    activity_id : this.data.activity_id
                }
                http.post('/wapi/Business/getContactList',data).then(res=>{
                    if (res.success === true){
                        this.options_contact = res.data
                    }
                })
            },
            getContactFeedBackList(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }
                http.post('/wapi/Business/getContactFeedBackList',data).then(res=>{
                    if (res.success === true){
                        this.options_feedback = res.data
                    }
                })
            },
            getProductList(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id : this.data.distributor_id
                }
                http.post('/wapi/Business/getProductList',data).then(res=>{
                    if (res.success === true){
                        this.options_contactProduct = res.data
                    }
                })
            },
            // 获取拜访目的
            async getContactPurposeData(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                }
                await http.post('/wapi/Business/getContactPurposeData',data).then(res=>{
                    if(res.success == true){
                        this.options_contactPurpose = res.data
                    }
                })
            },
            getAddContactList(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    activity_id : this.data.activity_id

                }
                http.post('/wapi/Business/getAddContactList',data).then(res=>{
                    if (res.success === true){
                        this.contactList = res.data.array
                    }
                })
            },
            // 获取拜访联系人详情
            async getContactVisitInfo(activity_id,item){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    this.contactDisabled=true;
                    let data ={
                        activity_id : activity_id,
                        contact_id: item.contact_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Business/getContactVisitInfo',data).then(res=>{
                        if(res.success == true){
                            this.addContact = res.data.info;
                            this.todoContactList = res.data.todoArray;
                            for(let k=0;k<res.data.todoArray.length;k++){
                                let photoList = res.data.todoArray[k].photoList
                                for (let j = 0; j<photoList.length;j++ ){
                                    this.getImgUrl(photoList[j].photo_id,photoList[j].created_date,photoList[j],photoList)
                                }

                            }
                        }
                    })
                    this.contactDetail = JSON.parse(JSON.stringify(item));
                    loading.close()
                }catch (e) {
                    return e
                    loading.close()
                }

            },
            async getContactVisitInfo_remove(activity_id,item){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        activity_id : activity_id,
                        contact_id: item.contact_id
                    }
                    await http.post('/wapi/Business/delContactList',data).then(res=>{
                        if (res.success === true){
                            this.getAddContactList()
                            this.getContactList()
                            loading.close()
                            this.$message({
                                message:'移除成功',
                                type : 'success'
                            })
                        }
                    })
                }catch (e) {

                }
            },
            // 编辑待办事项
            editorTodoList(item,index){
                this.backlog = false;
                this.waitBool = true;
                this.index=index;
                this.addTodoDate =  JSON.parse(JSON.stringify(item));
                this.addTodoDate.distributor_name=this.title;
            },
            async SaveClick(){
                try {
                    if(!this.visitPurpose){
                        this.$message({
                            type: 'error',
                            message: '请选择拜访目的'
                        })
                        return false
                    }
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        institution_id : this.data.distributor_id,
                        activity_id : this.data.activity_id,
                        objective_id : this.visitPurpose
                    }
                    await http.post('/wapi/Business/savePurpose',data).then(res=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.init()
                        }else {
                            this.$message({
                                type: 'error',
                                message: '保存失败'
                            })
                        }
                    })
                }catch (e) {
                    console.log(`error:${e}`)
                }
            },
            async handleCompletedClick(){
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        institution_id : this.data.distributor_id,
                        activity_id : this.data.activity_id,
                        completed : 'T'
                    }
                    await http.post('/wapi/Business/saveCompleted',data).then(res=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.init()
                        }else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                }catch (e) {
                    console.log(`error:${e}`)
                }
            },

            dialogVisibles(file) {
                this.dialogSrc = file.url
                this.dialogVisibleImg = true
            },
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            handleChange(file, fileList){
                this.fileList = fileList
                console.log(this.fileList)
            },
            // 上传图片成功
            handleImgSuccess(response, file, fileList) {
                // console.log(file)
                // this.fileList.push({
                //     name: file.name,
                //     url: file.url,
                //     response : file.response
                // });
                // this.editInventoryInfo()
            },
            beforeImgUpload(file) {


                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                const isLt20M = file.size / 1024 / 1024 < 20 * 1.2
                this.file_size = file.size

                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                if (!isLt20M) {
                    this.error('上传图片大小不能超过 20MB!')
                }
                const nameArr = file.name.split('.')
                return isPic && isLt20M
            },
            inputAddTodoList(){
                this.$refs["todoFormList"].validate(valid=> {
                    if (!valid) {
                        return false
                    } else {
                        this.addTodoList()
                    }
                })
            },
            async addTodoList(){
                this.todoContactList[this.index].title=this.addTodoDate.title
                this.todoContactList[this.index].duedate=this.addTodoDate.duedate
                this.todoContactList[this.index].content=this.addTodoDate.content
                this.waitBool = false

            },
            closeWaitBool(){
                this.waitBool=false;
                this.$refs['todoFormList'].resetFields()
                this.fileList = []
                this.copyFileList = []
            },
            async getImgUrl(id,date,item,arr) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }
                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data
                    item.url = array[0].thu_url
                    this.sortKey(arr, "created_date")
                    this.$forceUpdate()

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            sortKey(array, key) {
                return array.sort(function(a, b) {
                    var x = a[key];
                    var y = b[key];
                    return x > y ? 1 : x < y ? -1 : 0;
                });
            },
            newContactClick(){
                this.contactBool = true
                this.addContact={};
                this.addContact.activity_date=this.date;
                this.todoContactList=[];
                this.backlog = false;
                this.contactDisabled=false
            },
            backlogClick(){
                this.addTodo={
                    title:'',
                    duedate: '',
                    contact_name: '',
                    job_title:'',
                    distributor_name:'',
                    content:'',
                    reference_obj:'',
                    reference_id:'',
                };
            },
            inputAddTodoContactList(){
                this.$refs["todoForm"].validate(valid=> {
                    if (!valid) {
                        return false
                    } else {
                        this.addTodoContactList()
                    }
                })
            },
            addTodoContactList(){

                // if (!(this.newContact.contact_id)){
                //     this.$message({
                //         message:'请先选择人员',
                //         type : 'error'
                //     })
                //     return false
                // }
                if (!(this.addContact.contact_name)){
                    this.$message({
                        message:'请先选择人员',
                        type : 'error'
                    })
                    return false
                }
                if (!this.addTodo.title){
                    this.$message({
                        message: '请输入标题',
                        type: 'error'
                    });
                    return false
                }
                if (!this.addTodo.duedate){
                    this.$message({
                        message: '请选择截止日期',
                        type: 'error'
                    });
                    return false
                }

                if(Object.keys(this.newContact).length !== 0){
                    this.addTodo.contact_name=this.newContact.contact_name;
                    this.addTodo.job_title=this.newContact.job_title;
                    this.addTodo.reference_obj=this.newContact.reference_obj;
                    this.addTodo.reference_id=this.newContact.reference_id;
                    this.addTodo.contact_id = this.newContact.contact_id;
                    this.todoContactList.push(this.addTodo)
                    this.addTodo={
                        title:'',
                        duedate: '',
                        contact_name: '',
                        job_title:'',
                        distributor_name:'',
                        department:'',
                        content:'',
                        reference_obj:'',
                        reference_id:'',
                    };
                }else{
                    this.addTodo.contact_name=this.contactDetail.contact_name;
                    this.addTodo.job_title=this.contactDetail.job_title;
                    this.addTodo.department=this.contactDetail.department;
                    this.addTodo.reference_obj='CONTACT';
                    this.addTodo.reference_id=this.contactDetail.contact_id;
                    this.addTodo.call_id = this.contactDetail.activity_id;
                    this.addTodo.contact_id = this.contactDetail.contact_id;
                    this.todoContactList.push(this.addTodo)
                    this.addTodo={
                        title:'',
                        duedate: '',
                        contact_name: '',
                        job_title:'',
                        distributor_name:'',
                        department:'',
                        content:'',
                        reference_obj:'',
                        reference_id:'',
                    };
                    this.$forceUpdate()
                }
            },
            inputAddContact(){
                this.$refs["contactForm"].validate(valid=> {
                    if (!valid) {
                        return false
                    } else {
                        this.addContactClick()
                    }
                })
            },
            async addContactClick(){
                try{
                    let loading = this.$loading({
                        lock: true,
                        text: '拼命加载中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    if(!(this.addContact.key_id)){
                        let str = this.data.activity_date;
                        let approvedates = str.replace(/[年月]/g,"-");
                        let date = approvedates.replace(/[日]/,"");
                        date=moment(date).format('YYYY-MM-DD')
                        let data ={
                            objective_id:this.addContact.objective_id,
                            activity_id:this.data.activity_id,
                            activity_date:date,
                            feedback:this.addContact.feedback,
                            conversation:this.addContact.conversation ? this.addContact.conversation : '' ,
                            user_id:this.$store.getters.getUser.user_id,
                            tenant_id:this.$store.getters.getUser.tenant_id,
                            start_time:date,
                            distributor_id:this.data.distributor_id,
                            contact_id:this.addContact.contact_name.contact_id,
                            todo:[],
                            product_id: this.addContact.product_id,
                            segment_id :this.addContact.contact_name.segment_id,
                            reference_obj : this.addContact.contact_name.reference_obj,
                            reference_id : this.addContact.contact_name.reference_id
                        }
                        data.todo=this.todoContactList;
                        data.territory_id = this.territory_id
                        await http.post('/wapi/Business/saveContactVisitInfo',data).then(res=>{
                            if(res.success == true){
                                loading.close()
                                this.contactBool = false
                                this.$message({
                                    type: 'success',
                                    message: '保存成功',
                                })
                            }
                            this.init()
                        })
                    }else{
                        this.backlog = false;
                        let str = this.data.activity_date;
                        let approvedates = str.replace(/[年月]/g,"-");
                        let date = approvedates.replace(/[日]/,"");
                        date=moment(date).format('YYYY-MM-DD')
                        let data ={
                            objective_id:this.addContact.objective_id,
                            activity_id:this.data.activity_id,
                            activity_date:date,
                            feedback:this.addContact.feedback,
                            conversation:this.addContact.conversation ? this.addContact.conversation : '' ,
                            user_id:this.$store.getters.getUser.user_id,
                            tenant_id:this.$store.getters.getUser.tenant_id,
                            start_time:date,
                            key_id:this.addContact.key_id,
                            distributor_id:this.data.distributor_id,
                            contact_id:this.addContact.contact_name.contact_id,
                            todo:[],
                            product_id: this.addContact.product_id,
                            segment_id :this.addContact.contact_name.segment_id,
                            reference_obj : this.addContact.contact_name.reference_obj,
                            reference_id : this.addContact.contact_name.reference_id
                        }
                        data.todo=this.todoContactList;
                        data.territory_id = this.territory_id
                        await http.post('/wapi/Business/saveContactVisitInfo',data).then(res=>{
                            if(res.success == true){
                                loading.close()
                                this.contactBool = false
                                this.$message({
                                    type: 'success',
                                    message: '保存成功',
                                })
                            }
                            this.init()
                        })
                    }
                }catch (e) {

                }
            },
            choseProvince(item){
                this.newContact = item
            },
            closeAddBlock(){
                this.backlog = false;
            },
            closeAddBool(){
                this.contactBool = false
                this.$refs['contactForm'].resetFields();
            },
            handleClose(){

            }
        }
    }
</script>

<style scoped>
    /*#businessDetails {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #businessDetails >>>.el-form-item{
        margin-top: 10px;
        margin-bottom: 10px;
    }
    #business >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
        font-weight: bold;
    }
    #waitList >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #waitList >>>.el-form-item{
        margin-top: 10px;
    }
    #backlog >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
        margin-left: 20px;
    }
    #back >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }
    #businessDetails >>>.el-tag.el-tag--info{
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }
    #businessDetails >>>.el-tag.el-tag--info .el-tag__close{
        display: none;
    }
    #businessDetails >>> .el-dialog__header{
        padding-top: 0px ;
    }
    #backlog >>>.el-form-item__error{
        margin-left: 20px;
    }
    #backlog >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
        margin-left: 20px;
    }
    #businessDetails >>> .el-dialog__body{
        padding: 10px 20px 20px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/businessDetails.vue